import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  stockHistoryModalTitle: {
    description: 'Stock history modal title',
    defaultMessage: 'Stock History',
    id: 'C/1oVl',
  },
  inventoryHistoryModalClose: {
    description: 'Inventory history close button',
    defaultMessage: 'Close',
    id: '2LaOaF',
  },
  inventoryHistoryModalSku: {
    description: 'Inventory history Sku label',
    defaultMessage: 'Product Sku',
    id: 'jXSeYW',
  },
  inventoryHistoryModalName: {
    description: 'Inventory history Name label',
    defaultMessage: 'Product Name',
    id: 'uPOznF',
  },
  inventoryHistoryModalWarehouse: {
    description: 'Inventory history Warehouse label',
    defaultMessage: 'Warehouse',
    id: 'htox+O',
  },
  inventoryHistoryModalLocation: {
    description: 'Inventory history Location label',
    defaultMessage: 'Location',
    id: 'yHSWJb',
  },
  inventoryHistoryModalLotID: {
    description: 'Inventory history Lot ID label',
    defaultMessage: 'Lot ID',
    id: '8vyMNp',
  },
  inventoryHistoryExpirationDate: {
    description: 'Inventory history Expiration Date label',
    defaultMessage: 'Expiration Date',
    id: '+Ccm9r',
  },
  inventoryHistoryLotIDHeader: {
    description: 'Inventory history lot ID header',
    defaultMessage: 'Lot ID',
    id: '1MUEcc',
  },
  inventoryHistoryExpirationDateHeader: {
    description: 'Inventory history expiration date header',
    defaultMessage: 'Exp Date',
    id: '6RkLrI',
  },
  inventoryHistoryUnitsHeader: {
    description: 'Inventory history units header',
    defaultMessage: 'Units',
    id: 'aLeGQf',
  },
  inventoryHistoryCostHeader: {
    description: 'Inventory history cost header',
    defaultMessage: 'Cost',
    id: 'R9nsDS',
  },
  inventoryHistoryDateHeader: {
    description: 'Inventory history date header',
    defaultMessage: 'Date',
    id: 'u+pWcf',
  },
  inventoryHistoryWarehouseHeader: {
    description: 'Inventory history warehouse header',
    defaultMessage: 'Warehouse',
    id: '2ml59X',
  },
  inventoryHistoryLocationHeader: {
    description: 'Inventory history Location header',
    defaultMessage: 'Location',
    id: '3o0GcH',
  },
  inventoryHistoryUserHeader: {
    description: 'Inventory history User header',
    defaultMessage: 'User',
    id: '0G2PJS',
  },
  inventoryHistoryDescriptionHeader: {
    description: 'Inventory Description User header',
    defaultMessage: 'Description',
    id: 'uMEEmY',
  },
  inventoryHistoryTypeHeader: {
    description: 'Inventory Description Type header',
    defaultMessage: 'Type',
    id: 'Lx/WUQ',
  },
  inventoryTransactionTypeAdd: {
    description: 'Inventory Transaction Type - Add',
    defaultMessage: 'Add',
    id: 'eNREbP',
  },
  inventoryTransactionTypeRemove: {
    description: 'Inventory Transaction Type - Remove',
    defaultMessage: 'Remove',
    id: 'fSPwwM',
  },
  inventoryTransactionTypeAllocate: {
    description: 'Inventory Transaction Type - Allocate',
    defaultMessage: 'Allocate',
    id: 'xOPpkx',
  },
  inventoryTransactionTypeReleaseAllocation: {
    description: 'Inventory Transaction Type - ReleaseAllocation',
    defaultMessage: 'Release Allocation',
    id: 'bLLOiX',
  },
  inventoryTransactionTypeCommitAllocation: {
    description: 'Inventory Transaction Type - CommitAllocation',
    defaultMessage: 'Commit Allocation',
    id: 'g+s4xU',
  },
  inventoryTransactionTypeMove: {
    description: 'Inventory Transaction Type - Move',
    defaultMessage: 'Move',
    id: 'zoh38N',
  },
  inventoryHistoryNoRecords: {
    description: 'Inventory history no records',
    defaultMessage: 'No Inventory History records have been recorded',
    id: '6YFTuq',
  },
});
